// extracted by mini-css-extract-plugin
export var divider = "_xo-0";